import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QueueService {

  constructor(private http: HttpClient) {}
  private apiUrl = environment.apiUrl;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  getJobInfo(jobName: string) {
		return this.http.get<any>(`${this.apiUrl}/jobs/${jobName}`,  this.httpOptions);
	}

  removeJobFromQueue(jobName: string,data:any) {
		return this.http.post<any>(`${this.apiUrl}/jobs/${jobName}`,{data},  this.httpOptions);
	}
}
